module.exports = __webpack_public_path__ + "img/learnEnglishMain.b812d28d.png";